import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import type { RootState, AppDispatch } from '../store/index.js';
import { fetchCurrentUser, logout as logoutAction } from '../store/authSlice.js';
import type { UserRole } from '../../shared/types.js';

export function useAuth() {
  const dispatch = useDispatch<AppDispatch>();
  const { user, loading, initialized, error } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    if (!initialized && !loading) {
      dispatch(fetchCurrentUser());
    }
  }, [dispatch, initialized, loading]);

  const isAuthenticated = !!user;

  const hasRole = (roles: UserRole[]): boolean => {
    if (!user) return false;
    return roles.includes(user.role);
  };

  const doLogout = () => dispatch(logoutAction());

  return { user, loading, initialized, error, isAuthenticated, hasRole, logout: doLogout };
}
